import React from 'react';
import { useTranslation } from 'react-i18next';

interface VideoPromptInputProps {
  videoPrompt: string;
  setVideoPrompt: (prompt: string) => void;
}

const VideoPromptInput: React.FC<VideoPromptInputProps> = ({
  videoPrompt,
  setVideoPrompt,
}) => {
  const { t } = useTranslation('aiGenerator');
  
  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
        {t('video.promptLabel')}
      </label>
      <textarea
        placeholder={t('video.promptPlaceholder')}
        value={videoPrompt}
        onChange={(e) => setVideoPrompt(e.target.value)}
        style={{
          width: '100%',
          height: '80px',
          padding: '12px',
          border: '1px solid rgba(139, 92, 246, 0.3)',
          borderRadius: '8px',
          backgroundColor: '#1a1a1a',
          color: 'white',
          fontSize: '14px',
          resize: 'vertical',
          fontFamily: 'inherit',
          outline: 'none'
        }}
      />
    </div>
  );
};

export default VideoPromptInput;